import { useEffect, useRef } from 'react'

// Owns the gallery's scroll container: snaps back to the top when the filter
// signature changes (while keepPreviousData still shows the dimmed previous grid)
// and loads the next page when the sentinel below the columns scrolls into view.
function useGalleryScroll({ signature, hasNextPage, isFetchingNextPage, onLoadMore }) {
  const scrollRef = useRef(null)
  const sentinelRef = useRef(null)
  const previousSignatureRef = useRef(signature)

  useEffect(() => {
    if (previousSignatureRef.current === signature) return
    previousSignatureRef.current = signature
    scrollRef.current?.scrollTo({ top: 0, behavior: 'smooth' })
  }, [signature])

  useEffect(() => {
    const root = scrollRef.current
    const sentinel = sentinelRef.current
    if (!root || !sentinel || !hasNextPage || isFetchingNextPage) return undefined

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) onLoadMore()
      },
      { root, rootMargin: '200px', threshold: 0 },
    )

    observer.observe(sentinel)
    return () => observer.disconnect()
  }, [hasNextPage, isFetchingNextPage, onLoadMore])

  return [scrollRef, sentinelRef]
}

export default useGalleryScroll
